import type {
    PracticeMemberUsageSortBy,
    PracticeMemberUsageSortDirection,
} from '@/entities/reporting';

export function getAriaSort(
    column: PracticeMemberUsageSortBy,
    sortBy: PracticeMemberUsageSortBy,
    sortDirection: PracticeMemberUsageSortDirection,
): 'ascending' | 'descending' | undefined {
    if (column !== sortBy) return undefined;
    return sortDirection === 'asc' ? 'ascending' : 'descending';
}
